import type { I18n } from '@lingui/core';

/**
 * The role an item is assigned to (`models.Role*`), in words. An unknown value
 * returns `null` so no surface ever prints a raw role key.
 */
export function assignedRoleLabel(i18n: Pick<I18n, '_'>, role: string): string | null {
  switch (role) {
    case 'admin':
      return i18n._({ id: 'workflow.role.admin', message: 'Administration' });
    case 'manager':
      return i18n._({ id: 'workflow.role.manager', message: 'Management' });
    case 'shift_manager':
      return i18n._({ id: 'workflow.role.shiftManager', message: 'Shift planning' });
    case 'billing_admin':
      return i18n._({ id: 'workflow.role.billingAdmin', message: 'Billing' });
    case 'educator':
      return i18n._({ id: 'workflow.role.educator', message: 'Educators' });
    default:
      return null;
  }
}
